import { PayloadAction } from '@reduxjs/toolkit';

import { IState } from '../types/state';
import { FavoriteFolder } from 'dataSources/Typicode/favoriteCatalogs';

const action = (
  state: IState,
  payloadAction: PayloadAction<FavoriteFolder>,
) => {
  const { id, name } = payloadAction.payload;

  state.catalogs.data = {
    ...state.catalogs.data,
    [id]: {
      ...state.catalogs.data[id],
      name,
    },
  };
};

export default action;
